//import {getEwGroups} from '../enterworks'
export const FETCH_EWGROUPS_BEGIN = "FETCH_EWGROUPS_BEGIN"
export const FETCH_EWGROUPS_SUCCESS ="FETCH_EWGROUPS_SUCCESS"
export const FETCH_EWGROUPS_FAILURE = "FETCH_EWGROUPS_FAILURE"
export const SET_EWGROUP_SELECT = "SET_EWGROUP_SELECT"
export const SET_EWGROUP_NULL = "SET_EWGROUP_NULL"
export const FILTER_EWGROUP = 'FILTER_EWGRROUP'
export const CLEAR_GROUPS = "CLEAR_GROUPS"


function getEwGroups(){
  return fetch("/iframeApi/groups")
  .then(handleErrors)
  .then(res => res.json());
}

const cGroups = () => ({
  type : CLEAR_GROUPS
})

const filterEwGroup = (roles, index) => ({
  type: FILTER_EWGROUP,
  payload : {roles, index}
});

const fetchEwGroupsBegin = () => ({
    type: FETCH_EWGROUPS_BEGIN
  });
  
const fetchEwGroupsSuccess = ewGroups => ({
    type: FETCH_EWGROUPS_SUCCESS,
    payload: { ewGroups }
  });
  
const fetchEwGroupsFailure = error => ({
    type: FETCH_EWGROUPS_FAILURE,
    payload: { error }
  });

  export const setEWGroupSelect = (group, index) => ({
    type: SET_EWGROUP_SELECT,
    payload: { group, index }
  });

  export const setEWGroupNuLL = () => ({
    type: SET_EWGROUP_NULL
  });
  
  export function selectEwGroup(group, index){
    return setEWGroupSelect(group, index)
}

export function clearGroups(){
  return cGroups()
}

export function removeEwGroupSelection(){
  return setEWGroupNuLL()
}

export function filterGroupByCo(roles, index){
  return filterEwGroup(roles, index)
}

export function fetchEwGroups() {
    return dispatch => {
      dispatch(fetchEwGroupsBegin());
      return getEwGroups()
        .then(json => {
          dispatch(fetchEwGroupsSuccess(json));
          return json;
        })
        .catch(error =>
          dispatch(fetchEwGroupsFailure(error))
        );
    };
  }

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }
  